import { DeleteFilled } from "@ant-design/icons"
import { Col, Row } from "antd"
import DataTable from "../../../components/DataTable/DataTable"
import { colors } from "../../../assets/styles/appStyles"
import DataTableRowsSkeleton from "../../../styledComponents/LoadingSkeletons/DataTableRowsSkeleton"
import TABLE_COLUMNS from "../const/MARKETPLACE_TIPS_TABLE_COLUMNS"
import { MarketplaceTipItem } from "../MarketplacesViewModel"

interface Props {
	tips: MarketplaceTipItem[]
	isLoading?: boolean
	onChange?: (tipId: number, value: MarketplaceTipItem) => void
	onDelete?: (tipId: number) => void
}

const MarketplaceTipsFormSection = ({ tips, isLoading, onChange, onDelete }: Props) => {
	const handleSave = (record: any) => {
		onChange &&
			onChange(record.id, {
				tipId: record.id,
				position: Number(record.position),
				tip: record.tip
			})
	}

	return (
		<Row gutter={[24, 0]}>
			<Col md={24} xl={24} xs={24}>
				<DataTable
					loading={isLoading}
					renderCustomLoadingComponent={() => <DataTableRowsSkeleton />}
					editableCells={{ handleSave }}
					columns={TABLE_COLUMNS()}
					dataSource={tips.map(item => ({
						key: item.tipId,
						id: item.tipId,
						tip: item.tip,
						user: item.tip.user?.email || "-",
						name: item.tip.user?.name || "-",
						description: (
							<p
								style={{
									color: "black",
									overflow: "hidden",
									textOverflow: "ellipsis",
									whiteSpace: "nowrap",
									maxWidth: "40rem"
								}}
							>
								{item.tip.description || "-"}
							</p>
						),
						position: item.position,
						actions: (
							<div key={item.tipId}>
								<DeleteFilled
									style={{ fontSize: "1.2rem", color: colors.error }}
									onClick={() => onDelete && onDelete(item.tipId)}
								/>
							</div>
						)
					}))}
				/>
			</Col>
		</Row>
	)
}

export default MarketplaceTipsFormSection
